import React, { forwardRef } from 'react';
import { FormField } from '../FormField.tsx';

export interface TextAreaInputProps extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'className'> {
  label?: string;
  error?: string;
  required?: boolean;
  hint?: string;
}

const inputClassName = (error?: string) =>
  `w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-50 disabled:bg-gray-50 min-h-[80px] ${
    error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300'
  }`;

export const TextAreaInput = forwardRef<HTMLTextAreaElement, TextAreaInputProps>(
  ({ label, error, required, hint, id, ...rest }, ref) => (
    <FormField label={label} error={error} required={required} hint={hint} htmlFor={id}>
      <textarea
        ref={ref}
        id={id}
        className={inputClassName(error)}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
        {...rest}
      />
    </FormField>
  )
);

TextAreaInput.displayName = 'TextAreaInput';
